import React, { memo } from 'react'
import styles from './styles.module.scss'
import { useGuestCount } from './useGuestCount.hook'
import GuestCountInput from './GuestCountInput'
import ProgressBar from '../ProgressBar'

interface GuestCountTextProps {
  title: string
  onSubmit: () => void
  isValid: boolean
  hasValue: boolean
}

/* eslint-disable react/prop-types */
const GuestCountText: React.FC<GuestCountTextProps> = memo(({ title, onSubmit, isValid, hasValue }) => (
  <div className={styles.guestCountTextContainer}>
    <span className={styles.guestCountTitle}>{title}</span>
    <button
      className={`${styles.guestCountButton} ${hasValue ? styles.hasValue : ''}`}
      onClick={onSubmit}
      disabled={!isValid}
    >
      Next
    </button>
  </div>
))

GuestCountText.displayName = 'GuestCountText'

const GuestCountPage: React.FC = () => {
  const { guestCount, error, isValid, handleGuestCountChange, handleSubmitGuestCount } = useGuestCount()

  return (
    <>
      <ProgressBar />
      <div className={styles.guestCountPage}>
        <section className={styles.guestCountLeftSection}>
          <GuestCountText
            title="About how many guests are you expecting?"
            onSubmit={handleSubmitGuestCount}
            isValid={isValid}
            hasValue={guestCount.length > 0}
          />
        </section>

        <section className={styles.guestCountRightSection}>
          <div className={styles.guestCountInputWrapper}>
            <GuestCountInput
              value={guestCount}
              error={error}
              onChange={handleGuestCountChange}
              onSubmit={handleSubmitGuestCount}
            />
          </div>
        </section>
        <button
          className={`${styles.guestCountButtonMobile} ${guestCount.length > 0 ? styles.hasValue : ''}`}
          onClick={handleSubmitGuestCount}
          disabled={!isValid}
        >
          Next
        </button>
      </div>
    </>
  )
}

GuestCountPage.displayName = 'GuestCountPage'

export default memo(GuestCountPage)
